export default {
  KEY1: [
    {
      id: 1,
      word: "当社"
    },
    {
      id: 2,
      word: "当組合"
    },
    {
      id: 3,
      word: "当法人"
    },
    {
      id: 4,
      word: "当財団"
    },
    {
      id: 5,
      word: "当組織"
    },
    {
      id: 6,
      word: "当グループ"
    },
    {
      id: 7,
      word: "当行"
    },
    {
      id: 8,
      word: "当金庫"
    },
    {
      id: 9,
      word: "当校"
    },
    {
      id: 10,
      word: "当院"
    },
    {
      id: 11,
      word: "当園"
    },
    {
      id: 12,
      word: "当団体"
    },
    {
      id: 13,
      word: "当県"
    },
    {
      id: 14,
      word: "当市"
    },
    {
      id: 15,
      word: "当町"
    },
    {
      id: 16,
      word: "当庁"
    },
    {
      id: 17,
      word: "当省"
    }
  ],
  KEY2: [
    {
      id: 1,
      word: "社員"
    },
    {
      id: 2,
      word: "従業員"
    },
    {
      id: 3,
      word: "組合員"
    },
    {
      id: 4,
      word: "職員"
    },
    {
      id: 5,
      word: "メンバー"
    }
  ],
  KEY3: [
    {
      id: 1,
      word: "経営トップ層"
    },
    {
      id: 2,
      word: "役員"
    },
    {
      id: 3,
      word: "パートナー"
    }
  ],
  KEY4: [
    {
      id: 1,
      word: "上司"
    },
    {
      id: 2,
      word: "管理者"
    },
    {
      id: 3,
      word: "監督者"
    },
    {
      id: 4,
      word: "上長"
    }
  ],
  KEY5: [
    {
      id: 1,
      word: "部署"
    },
    {
      id: 2,
      word: "チーム"
    },
    {
      id: 3,
      word: "営業所"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/data/Keywords.js